import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  inject,
  Input,
} from '@angular/core';
import { AbilityServiceSignal } from '@casl/angular';
import { TranslateModule } from '@ngx-translate/core';
import { AuthorizationModule } from '@wilson/authorization';
import { RoleAction, RolePermissionSubject } from '@wilson/interfaces';
import {
  CreateNewViaDragAndDropService,
  DragAndDropModeService,
} from '@wilson/shift-timeline/services';
import { NzTooltipModule } from 'ng-zorro-antd/tooltip';

export interface EmptyAbsenceDragDropDataTransfer {
  isCreateNewAbsence: true;
}

@Component({
  selector: 'wilson-new-absence-quick-action-card',
  imports: [
    CommonModule,
    TranslateModule,
    AuthorizationModule,
    NzTooltipModule,
  ],
  templateUrl: './new-absence-quick-action-card.component.html',
  styleUrls: ['./new-absence-quick-action-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NewAbsenceQuickActionCardComponent {
  private dragAndDropModeService = inject(DragAndDropModeService);
  createNewViaDragAndDropService = inject(CreateNewViaDragAndDropService);

  @Input() isQuickCreationCardOpen = true;

  protected RoleAction = RoleAction;
  protected RolePermissionSubject = RolePermissionSubject;
  protected can = inject(AbilityServiceSignal).can;

  startDrag(event: DragEvent): void {
    const transferData: EmptyAbsenceDragDropDataTransfer = {
      isCreateNewAbsence: true,
    };

    event.dataTransfer?.setData(
      'application/json',
      JSON.stringify(transferData),
    );

    this.dragAndDropModeService.setDraggingItemId(
      CreateNewViaDragAndDropService.MOCK_ABSENCE_ID,
    );
    this.createNewViaDragAndDropService.setEnableNewAbsenceDropZone(true);
    this.dragAndDropModeService.setDisplayTimeVisible(false);
  }

  dragEnd(): void {
    this.dragAndDropModeService.setDraggingItemId(null);
    this.createNewViaDragAndDropService.setEnableNewAbsenceDropZone(false);
  }
}
